import styled from 'styled-components';

export const AccessorizedViewContent = styled.div`
  flex: 1;
`;
